export default __webpack_public_path__ + "images/XQ.0e3408b.png";